"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Coffee } from "lucide-react";
import { useEffect, useRef, useState } from "react";
export default function StayConnected() {
  const {
    ref: cardRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const [email, setEmail] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const decorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (decorRef.current) {
        const scrollY = window.scrollY;
        const offset = scrollY * 0.2;
        decorRef.current.style.transform = `translateY(${offset}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleButtonClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 600);
  };
  return <section className="relative bg-background py-24 px-4 overflow-hidden">
      {}
      <div ref={decorRef} className="absolute top-1/4 right-1/4 opacity-10 pointer-events-none" style={{
      willChange: "transform"
    }}>
        <Coffee className="w-32 h-32 text-primary" strokeWidth={1} />
      </div>

      <div className="max-w-2xl mx-auto relative z-10">
        <Card ref={cardRef} className={`
            bg-primary-light/15 backdrop-blur-sm shadow-soft border border-primary/10 
            transition-all duration-[350ms] ease-[var(--ease-out-back)]
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
          `}>
          <CardContent className="text-center space-y-6">
            <div className="space-y-3">
              <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
                Stay Connected
              </h2>
              <p className="text-muted-foreground text-base md:text-lg">
                Get the latest updates on Canada's finest specialty coffee roasters delivered to your inbox.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <Input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} className={`
                  flex-1 bg-background/80 border-primary/20 
                  focus-visible:border-primary focus-visible:ring-primary/30
                  transition-all duration-[250ms] ease-[var(--ease-smooth)]
                  ${isFocused ? "shadow-medium scale-[1.02]" : "shadow-soft"}
                `} />
              <Button onClick={handleButtonClick} className={`
                  bg-primary text-foreground-primary font-semibold px-8 py-3
                  hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5
                  active:bg-primary-active active:translate-y-0
                  focus-visible:ring-primary/40
                  transition-all duration-[250ms] ease-[var(--ease-spring)]
                  relative overflow-hidden
                  ${isClicked ? "shadow-strong" : "shadow-soft"}
                `}>
                {isClicked && <span className="absolute inset-0 bg-white/30 rounded-md animate-ping" style={{
                animationDuration: "600ms"
              }} />}
                <span className="relative">Subscribe</span>
              </Button>
            </div>

            <p className="text-xs text-muted-foreground">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>;
}